<div class="navbar-inner" [class.navbar-inner--mobile]="mobileView">
  <!-- Logo -->
  <img [id]="getID()" class="logo" [src]="logoSrc" (click)="logoRedirect()" alt="Inyova logo" />
  <ng-container *ngIf="!isRiskRecheck && !oddActive">
    <!-- Navigation -->
    <ng-container *ngIf="customer.email_confirmed && (currentAccount.step_status || onProductSwitch || customer.has_crowd_investor_account); else langMenu">
      <app-navbar-desktop *ngIf="!mobileView; else mobileNav"></app-navbar-desktop>
      <ng-template #mobileNav>
        <app-navbar-mobile></app-navbar-mobile>
      </ng-template>
    </ng-container>
    <ng-template #langMenu>
      <div [class.email-not-confirmed]="isLoggedIn && !customer.email_confirmed">
        @if (isLoggedIn && !customer.email_confirmed) {
          <a class="ds-ui-3" (click)="logout()"><span class="icon-i-logout"></span>{{ 'profile.logout' | translate }}</a>
        }
        <ul class="navbar-holder">
          <li class="navbar__item navbar__item--lang" (click)="isCountrySwitchOpen = !isCountrySwitchOpen" id="dropdown-trigger">
            <img src="{{ '/assets/images/' + domain + '-flag.svg' }}" />
            <span>|</span>
            {{ currentLanguage }}
          </li>
        </ul>
      </div>
    </ng-template>
  </ng-container>
</div>
<div class="country-switch-holder" *ngIf="isCountrySwitchOpen">
  <div class="country-switch-bg" (click)="close()"></div>
  <div class="country-switch-content">
    <h2>{{ 'modal.languageAndCountry.title' | translate }}</h2>
    <div class="close-btn">
      <img (click)="close()" class="close" src="/assets/images/close.svg" alt="close" width="16px" height="16px" />
    </div>
    <div class="dropdown">
      <label>{{ 'profile.language.title' | translate }}</label>
      <div class="dropdown-holder">
        <div class="dropdown-item with-arrow" (click)="isLanguageListOpen = !isLanguageListOpen; isCountryListOpen = false">
          {{ selectedLanguage?.fullName }}
        </div>
        <div class="dropdown-list" [ngClass]="{ open: isLanguageListOpen }">
          <div class="dropdown-list-item" *ngFor="let language of languages" (click)="changeLanguage(language)">
            {{ language.fullName }}
          </div>
        </div>
      </div>
    </div>
    <button (click)="saveCountrySwitch()" class="ui-button full-width">
      {{ 'modal.languageAndCountry.CTA' | translate }}
    </button>
  </div>
</div>
